export default class AdminLoteLicenciaForm {
    /**
     * 
     * @param {callback} options.onSuccess
     */
    nuevo(paqueteId, options) {
        let myself = this;
        let modalOpts = {
            title: 'Nuevo lote',
            method: 'POST',
            url: `/api/admin/paquetes/${paqueteId}/lotes-licencias`
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        let data = {
            id: 0, cantidad: 1, obs_publicacion: ''
        };
        this.modal.render(this.render(data));
    }

    /**
     * @param {number} paqueteId
     * @param {number} id
     * @param {callback} options.onSuccess
     */
    editar(paqueteId, id, options) {
        let myself = this;
        let modalOpts = {
            title: 'Editar lote',
            method: 'PUT',
            url: `/api/admin/paquetes/${paqueteId}/lotes-licencias/${id}`
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        Ajax.get(`/api/admin/paquetes/${paqueteId}/lotes-licencias/${id}`, {
            then: function (response) {
                myself.modal.render(myself.render(response.data));
            }
        });
    }

    render(data) {
        let htmlTxtCantidad = (data.id > 0) ? data.cantidad : `<input type="number" value="${data.cantidad}" id="cantidad" name="cantidad" min="1" class="form-control" required/>`;
        return `<form>
        <div class="row form-group">
            <label for="cantidad" class="col-form-label col col-md-4">Cantidad</label>
            <div class="col col-md-8">
                ${htmlTxtCantidad}
            </div>
        </div>
        <div class="row form-group">
            <label for="obs_publicacion" class="col-form-label col col-md-4">Detalle del lote</label>
            <div class="col col-md-8">
                <input type="text" value="${data.obs_publicacion}" id="obs_publicacion" name="obs_publicacion" class="form-control" required/>
            </div>
        </div>
        </form>`;
    }
}